const _code = Symbol();
const _shortDescription = Symbol();
const _longDescription = Symbol();
const _vald = Symbol();

const coalesce = (...args) => args.find(arg => arg !== undefined);

export class DiagnosisCode {
	constructor(code, shortDescription, longDescription, valid) {
		this.code = code;
		this.shortDescription = shortDescription;
		this.longDescription = longDescription;
		this.valid = valid;
	}
	get code() {
		return this[_code];
	}
	set code(v) {
		if(typeof v !== 'string')
			throw new TypeError('code must be a string.');
		this[_code] = v;
	}
	get shortDescription() {
		return this[_shortDescription];
	}
	set shortDescription(v) {
		if(typeof v !== 'string')
			throw new TypeError('shortDescription must be a string.');
		this[_shortDescription] = v;
	}
	get longDescription() {
		return this[_longDescription];
	}
	set longDescription(v) {
		if(typeof v !== 'string')
			throw new TypeError('longDescription must be a string.');
		this[_longDescription] = v;
	}
	get valid() {
		return this[_vald];
	}
	set valid(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('valid must be a boolean.');
		this[_vald] = v;
	}
	toJSON() {
		return {
			code: this.code,
			shortDescription: this.shortDescription,
			longDescription: this.longDescription,
			valid: this.valid
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			coalesce(obj.code, obj.Code, null),
			coalesce(obj.shortDescription, obj.ShortDescription, null),
			coalesce(obj.longDescription, obj.LongDescription, null),
			coalesce(obj.valid, obj.Valid, null)
		);
	}
}